module.exports = __webpack_public_path__ + "media/images/credit_cards/Discover-e48351cf89c69fd0e2a88e1d056bb50b.png";